var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#4D7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6452 7.08887L12.9108 6.35449L9.99935 9.26595L7.08789 6.35449L6.35352 7.08887L9.26497 10.0003L6.35352 12.9118L7.08789 13.6462L9.99935 10.7347L12.9108 13.6462L13.6452 12.9118L10.7337 10.0003L13.6452 7.08887Z",
    fill: "#4D7EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailClose);
export default __webpack_public_path__ + "static/media/email-close.09465d5d5cee26f947c3b6ebb817d01d.svg";
export { ForwardRef as ReactComponent };